import {
  index as baseIndex,
  request
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of gifted credit based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('gifted_credit_amounts', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * SPECIFIC FUNCTION                                                          *
 ******************************************************************************/

/**
 * gift an amount of credit
 *
 * @param data the new data of the partner
 */
export function giftCredit(client_account_id, quantity, comment) {
  let url = `/gifted_credit_amounts/gift/${client_account_id}`;
  let params = {
    quantity: quantity,
    comment: comment
  }
  return request(url, "POST", params);
}
